import SC from "./style";
import { useState, useEffect, useRef } from "react";
import { apiPost } from "api/callApi";
import { Button, Loader } from "InnoUI/components";
import theme from "theme";
import { getCompany } from "@store/company/actions";
import { useDispatch } from "react-redux";
import { convertBase64, convertToDDMMYYYY, regexTypes } from "utils/config";
import {
  CalendarDropdown,
  DisplayTemplateDropdown,
  InputField,
  TenantCoordinatorDropdown,
  TenantGroupDropdown,
  WeekDaysDropdown,
} from "components";
import { tenantReleaseStatus } from "utils/optionData/utils";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Label from "./Label";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { selectOccupant } from "@store/occupant/actions";
import useDebounce from "components/Debouncing";
import { showAlert } from "utils/helper";
import LevelDropdown from "components/LevelDropdown";
import ProjectTemplateOptionDropdown from "components/ProjectTemplateOptionDropdown";

function GeneralInformationForm(props) {
  const {
    onClose = () => {},
    occupantdata,
    isEditing,
    fetchData,
    rowId,
    Projectdata,
    levelId,
    isInfo,
    hideButtons,
    setOccupant = () => {},
    isLevel = false,
    setSelectedTabb = () => {},
  } = props;

  const [autoFillDate, setAutoFillDate] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState({
    projectId: Projectdata?.id,
    levelId: levelId,
    occupantGraphic: "",
    intervalCycle: "Week",
    calenderType: 0,
    boNotificationCalenderType: 0,
    excludeBuilderHolidays: 0,
    activityAlarm: 0,
    tenantStatus: 0,
    alarmInterval: 1,
    areaUnit: Projectdata?.unit,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [displayTemplateName, setDisplayTemplateName] = useState(
    isEditing ? occupantdata?.templateName || "" : "",
  );

  console.log(occupantdata, displayTemplateName, "occupantdata");

  const fileInputRefLogo = useRef(null);

  useEffect(() => {
    dispatch(getCompany());
    if (
      data.boNotificationDays == "" ||
      data.boNotificationDays == 0 ||
      data.boNotificationDays == null
    ) {
      setData((prevData) => ({
        ...prevData,
        boNotificationDate: null,
      }));
    }
  }, []);

  // Set initial data based on editing state
  useEffect(() => {
    if (isEditing) {
      setData(occupantdata);
      setDisplayTemplateName(occupantdata?.templateName || "");
    }
  }, [isEditing, occupantdata]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.displayTemplate) {
      setErrorMessage("Folder Template is required");
      return;
    }

    let updatedData = { ...data };

    if (!data.occupantOpeningDate) {
      updatedData = {
        ...updatedData,
        boPeriod: null,
        boStartDate: null,
        boEndDate: null,
        startMessage: null,
        endMessage: null,
        boNotificationDays: null,
        boNotificationDate: null,
        boNotificationstartMessage: null,
        boNotificationendMessage: null,
      };
    } else if (
      data.boNotificationDays === null ||
      data.boNotificationDays === ""
    ) {
      updatedData.boNotificationDate = null;
    }

    // if (!data.occupantOpeningDate && !autoFillDate) {
    //   showAlert("Warning", "Occupant opening date is required", "warning");
    //   return;
    // }
    setLoading(true);

    try {
      const endpoint = isEditing
        ? `/v1/editoccupant/${rowId}`
        : `/v1/addoccupant`;
      const response = await apiPost(endpoint, updatedData);
      setLoading(false);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      if (!isInfo) {
        // await fetchData();
        setOccupant((prevData) =>
          isEditing
            ? prevData.map((occupant) =>
                occupant.id == rowId ? response.data : occupant,
              )
            : [response.data, ...prevData],
        );

        onClose();
        setSelectedTabb(0);
      }
      const updatedOccupantData = response.data;
      if (isEditing && isInfo) {
        dispatch(selectOccupant(updatedOccupantData));
      }
    } catch (error) {
      console.error("Error:", error);
      showAlert({
        title: "error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = async (property, value, label) => {
    if (property === "displayTemplate") {
      setErrorMessage("");
    }

    if (property === "occupantArea") {
      if (value === "0" || value === "00" || value === "000") {
        return;
      }
    }
    if (isEditing && property === "displayTemplate") {
      const userConfirmed = await showAlert({
        title: "Are you sure?",
        text: "All the previous Template Data will be lost.",
        icon: "warning",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!userConfirmed) {
        return;
      }
    }
    if (property === "displayTemplate") {
      setDisplayTemplateName(label || "");
    }
    if (property == "boNotificationDays") {
      if (value == "0" || value == "" || value == "00" || value == null) {
        setData((prevData) => ({
          ...prevData,
          boNotificationDate: null,
          boNotificationDays: null,
        }));
      } else {
        setData((prevData) => ({
          ...prevData,
          boNotificationDays: value,
        }));
      }
    }

    if (property === "boPeriod") {
      if (value == "0" || value == "" || value == "00") {
        setData((prevData) => ({
          ...prevData,
          excludeBuilderHolidays: 0,
          boNotificationDays: null,
          boNotificationDate: null,
          boStartDate: null,
          boEndDate: null,
          startMessage: null,
          endMessage: null,
        }));
      } else {
        setData((prevData) => ({
          ...prevData,
          boPeriod: value,
        }));
      }
    }
    const processedValue =
      typeof value === "string" ? value.trimStart() : value;

    setData((prevData) => ({
      ...prevData,
      [property]: processedValue,
    }));
  };

  // const handleCheckboxChange = (e) => {
  //   const isChecked = e.target.checked;
  //   setAutoFillDate(isChecked);

  //   if (isChecked) {
  //     const formattedDate = convertToDDMMYYYY(Projectdata?.openingDate);
  //     handleChange("occupantOpeningDate", formattedDate || null);
  //   }
  // };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setAutoFillDate(isChecked);

    if (isChecked) {
      const formattedDate = convertToDDMMYYYY(Projectdata?.openingDate);
      const dateValue = formattedDate || null;

      handleChange("occupantOpeningDate", dateValue);
      if (dateValue === null) {
        handleChange("boPeriod", null);
        handleChange("boStartDate", null);
        handleChange("boEndDate", null);
        handleChange("startMessage", null);
        handleChange("endMessage", null);
        handleChange("boNotificationDays", null);
        handleChange("boNotificationDate", null);
        handleChange("boNotificationstartMessage", null);
        handleChange("boNotificationendMessage", null);
      }
    }
  };

  const fetchBoDate = async ({
    boPeriodType,
    boPeriod,
    calenderType,
    excludeBuilderHolidays,
    occupantOpeningDate,
    countryName,
    setFields,
  }) => {
    try {
      const response = await apiPost("/v1/getboperiod", {
        boPeriod,
        calenderType,
        excludeBuilderHolidays,
        occupantOpeningDate,
        countryName,
        projectId: Projectdata?.id,
      });

      const { start, end } = response.data;

      setData((prevData) => ({
        ...prevData,
        [setFields.startDate]: start.date,
        [setFields.endDate]: end.date,
        [setFields.startMessage]: start.message,
        [setFields.endMessage]: end.message,
      }));
    } catch (error) {
      console.error(`Error fetching ${boPeriodType} BO Date:`, error);
    }
  };

  const debouncedBoPeriod = useDebounce(data.boPeriod, 500);
  useEffect(() => {
    if (debouncedBoPeriod === 0 || debouncedBoPeriod === "") return;
    if (
      debouncedBoPeriod != 0 &&
      debouncedBoPeriod != "" &&
      data.calenderType !== null &&
      data.excludeBuilderHolidays !== null &&
      data.occupantOpeningDate !== null
    ) {
      fetchBoDate({
        boPeriodType: "Standard",
        boPeriod: debouncedBoPeriod,
        calenderType: data.calenderType,
        excludeBuilderHolidays: data.excludeBuilderHolidays,
        occupantOpeningDate: data.occupantOpeningDate,
        countryName: Projectdata?.countryName,
        setFields: {
          startDate: "boStartDate",
          endDate: "boEndDate",
          startMessage: "startMessage",
          endMessage: "endMessage",
        },
      });
    }
  }, [
    debouncedBoPeriod,
    data?.calenderType,
    data?.excludeBuilderHolidays,
    data?.occupantOpeningDate,
    Projectdata?.countryName,
  ]);

  const debouncedBoNotificationDays = useDebounce(data.boNotificationDays, 500);

  useEffect(() => {
    if (
      debouncedBoNotificationDays == "" ||
      debouncedBoNotificationDays == 0 ||
      debouncedBoNotificationDays == null
    )
      return;
    if (
      debouncedBoNotificationDays &&
      data?.boNotificationCalenderType !== null &&
      data?.excludeBuilderHolidays !== null &&
      data?.boStartDate !== null
    ) {
      fetchBoDate({
        boPeriodType: "Notification",
        boPeriod: debouncedBoNotificationDays,
        calenderType: data?.boNotificationCalenderType,
        excludeBuilderHolidays: data?.excludeBuilderHolidays,
        occupantOpeningDate: data?.boStartDate,
        countryName: Projectdata?.countryName,
        setFields: {
          startDate: "boNotificationStartDate",
          endDate: "boNotificationDate",
          startMessage: "boNotificationstartMessage",
          endMessage: "boNotificationendMessage",
        },
      });
    }
  }, [
    debouncedBoNotificationDays,
    data.boNotificationCalenderType,
    data.excludeBuilderHolidays,
    data.boStartDate,
    Projectdata?.countryName,
  ]);

  const handleRemoveImage = (type) => {
    setData((prevData) => ({
      ...prevData,
      [type]: "",
    }));
  };

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    try {
      const base64Image = await convertBase64(file, 5 * 1024 * 1024);
      setData((prevData) => ({
        ...prevData,
        [type]: base64Image.preview,
      }));
    } catch (error) {
      alert(error);
    } finally {
      e.target.value = "";
    }
  };

  return (
    <>
      {loading && <Loader />}
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper
          style={
            isInfo
              ? {
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "center",
                }
              : { padding: "15px 0px 20px 15px" }
          }
        >
          <div
            style={{
              width: "100%",
              borderRight: isInfo
                ? `1px solid ${theme.colors.themeColor}`
                : "none",
            }}
          >
            <SC.LabelContainer>
              <SC.Label>
                Occupant Name <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <InputField
                    name="occupantName"
                    value={data.occupantName}
                    onChange={handleChange}
                    required
                    // capitalize
                    maxLength={40}
                    // regexType={regexTypes.textNumberSumbole}
                    disabled={hideButtons}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>
                Occupant Number <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <InputField
                    name="occupantNo"
                    value={data.occupantNo}
                    onChange={handleChange}
                    required
                    maxLength={15}
                    regexType={regexTypes.textNumberSumbole}
                    uppercase
                    disabled={hideButtons}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            {/* Folder Template */}
            {isLevel && (
              <SC.LabelContainer>
                <SC.Label>
                  Select Level <SC.Astrik>*</SC.Astrik>
                </SC.Label>
                <SC.Children>
                  <SC.Wrapper>
                    <LevelDropdown
                      name="levelId"
                      defaultValue={data?.levelId}
                      projectId={Projectdata?.id}
                      onChange={handleChange}
                    />
                  </SC.Wrapper>
                </SC.Children>
              </SC.LabelContainer>
            )}
            <SC.LabelContainer>
              <SC.Label>
                Folder Template <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  {data.displayTemplate && (
                    <SC.DisplayTemplateName
                      title={displayTemplateName || data.displayTemplate}
                    >
                      {displayTemplateName || data.displayTemplate}
                    </SC.DisplayTemplateName>
                  )}

                  <ProjectTemplateOptionDropdown
                    name="displayTemplate"
                    onChange={handleChange}
                    defaultValue={data.displayTemplate}
                    projectId={Projectdata?.id}
                    width={data.displayTemplate ? "200px" : "80%"}
                    asChangePicker={!!data.displayTemplate}
                  />
                </SC.Wrapper>
                {errorMessage && (
                  <span
                    style={{ color: theme.colors.themeColor, fontSize: "12px" }}
                  >
                    {errorMessage}
                  </span>
                )}
              </SC.Children>
            </SC.LabelContainer>

            {/* Logo Image Upload */}
            <Label label="Occupant Graphic">
              <SC.Wrapper
                style={{ position: "relative", display: "inline-block" }}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "occupantGraphic")}
                  style={{ display: "none" }}
                  ref={fileInputRefLogo}
                />
                <Button
                  caption="Choose file"
                  onClick={() => fileInputRefLogo.current.click()}
                  fontSize="12px"
                  style={{
                    background: "#f3f3f3",
                    color: theme.colors.white,
                    minWidth: "100px",
                    height: "25px",
                    borderRadius: "3px",
                    border: "1px solid #949494",
                    position: "relative",
                    zIndex: "1",
                  }}
                  disabled={hideButtons}
                />
                <span style={{ fontSize: "11px", marginLeft: "5px" }}>
                  Please select a file with size up to 5MB.
                </span>
                {data?.occupantGraphic && (
                  <div style={{ display: "flex", marginTop: "5px" }}>
                    <img
                      src={data?.occupantGraphic}
                      alt={""}
                      style={{
                        maxWidth: "50px",
                        maxHeight: "50px",
                        objectFit: "cover",
                      }}
                    />
                    {!hideButtons && (
                      <SC.CloseIcon
                        onClick={() => handleRemoveImage("occupantGraphic")}
                      />
                    )}
                  </div>
                )}
              </SC.Wrapper>
            </Label>

            <SC.LabelContainer>
              <SC.Label>
                Property Opening Date <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  {/* <span>{Projectdata?.openingDate || "df"}</span> */}
                  <InputField
                    name="openingDate"
                    value={convertToDDMMYYYY(Projectdata?.openingDate)}
                    onChange={handleChange}
                    required
                    disabled={true}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>Occupant Opening Date</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <DatePicker
                    name="occupantOpeningDate"
                    value={
                      data.occupantOpeningDate
                        ? dayjs(data.occupantOpeningDate, "YYYY-MM-DD")
                        : null
                    }
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                      // Ensure we only pass the date part
                      const formattedDate = value
                        ? dayjs(value).format("YYYY-MM-DD")
                        : "";
                      handleChange("occupantOpeningDate", formattedDate);
                    }}
                    disabled={autoFillDate || hideButtons}
                    mode="date"
                    showTime={false}
                    allowClear={true}
                    style={{ width: "45%", height: "29px" }}
                    disabledDate={(current) =>
                      current &&
                      current < dayjs(Projectdata?.openingDate, "YYYY-MM-DD")
                    }
                    // 👇 OPEN CALENDAR TO PROJECT OPENING DATE
                    defaultPickerValue={
                      Projectdata?.openingDate
                        ? dayjs(Projectdata.openingDate, "YYYY-MM-DD")
                        : undefined
                    }
                  />

                  <div>
                    <Checkbox
                      checked={autoFillDate}
                      name="checkbox"
                      onChange={handleCheckboxChange}
                      sx={{
                        "&.Mui-checked": {
                          color: theme.colors.themeColor,
                        },
                      }}
                      size="small"
                      disabled={hideButtons}
                    />
                    <span style={{ fontSize: "11px" }}>
                      Same as Property Opening Date
                    </span>
                  </div>
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>
                Occupant Area <SC.Astrik>*</SC.Astrik>
              </SC.Label>
              <SC.Children>
                <SC.Wrapper style={{ gap: "3px" }}>
                  <InputField
                    name="occupantArea"
                    value={data.occupantArea || ""}
                    onChange={handleChange}
                    required
                    type="number"
                    maxLength={15}
                    regexType={regexTypes.numberWithDecimal}
                    disabled={hideButtons}
                  />
                  <span>{Projectdata?.unit}</span>
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            {/* Gender Radio Group */}
            {!isInfo && (
              <Label label="Occupant Release Status">
                <RadioGroup
                  row
                  name="tenantStatus"
                  value={data?.tenantStatus}
                  onChange={(e) => handleChange("tenantStatus", e.target.value)}
                >
                  {tenantReleaseStatus.map((option) => (
                    <FormControlLabel
                      key={option.id}
                      value={option.id}
                      disabled={hideButtons}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 16,
                            },
                            "&.Mui-checked": {
                              color: "#EC810B",
                            },
                            margin: "0px 0px 0px 10px",
                          }}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </Label>
            )}

            <Label label="Occupant Release Date">
              <InputField
                name="tenantReleaseDate"
                value={data.tenantReleaseDate}
                onChange={handleChange}
                required
                type="number"
                disabled={true}
                maxLength={15}
              />
            </Label>
          </div>
          <div
            style={{
              width: "100%",
            }}
          >
            {/* Folder Template */}
            <SC.LabelContainer>
              <SC.Label>Occupant Group</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <TenantGroupDropdown
                    name="tenantGroup"
                    onChange={handleChange}
                    defaultValue={data.tenantGroup}
                    newItemLabel={"+ Add New Group"}
                    disabledDropdown={hideButtons}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            {/* Folder Template */}
            <SC.LabelContainer>
              <SC.Label>BO Period</SC.Label>
              <SC.Children>
                <SC.Wrapper style={{ gap: "5px" }}>
                  <InputField
                    name="boPeriod"
                    value={data.boPeriod}
                    onChange={handleChange}
                    type="number"
                    style={{ width: "12%" }}
                    maxLength={3}
                    regexType={regexTypes.number}
                    disabled={hideButtons || !data?.occupantOpeningDate}
                  />

                  <CalendarDropdown
                    name="calenderType"
                    onChange={handleChange}
                    defaultValue={data.calenderType}
                    disabledDropdown={hideButtons}
                  />

                  <Checkbox
                    checked={data.excludeBuilderHolidays == 1}
                    onChange={(e) =>
                      handleChange(
                        "excludeBuilderHolidays",
                        e.target.checked ? 1 : 0,
                      )
                    }
                    sx={{
                      "&.Mui-checked": {
                        color: theme.colors.themeColor,
                      },
                    }}
                    size="small"
                    disabled={!data.boPeriod || hideButtons}
                  />

                  <span style={{ marginBottom: "2px", fontSize: "11px" }}>
                    Exclude builders holiday
                  </span>
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>BO Date Will Be Between</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <InputField
                    name="boStartDate"
                    value={data.boStartDate}
                    onChange={handleChange}
                    required
                    style={{ width: "30%" }}
                    disabled={true}
                  />

                  <span style={{ marginLeft: "10px" }}>
                    {data.startMessage}
                  </span>
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>And</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <InputField
                    name="boEndDate"
                    value={data.boEndDate}
                    onChange={handleChange}
                    required
                    style={{ width: "30%" }}
                    disabled={true}
                  />

                  <span style={{ marginLeft: "10px" }}>{data.endMessage}</span>
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer
              style={{
                alignItems: "flex-start",
              }}
            >
              <SC.Label>BO Notification To Coordinator</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <InputField
                    name="boNotificationDays"
                    value={data.boNotificationDays}
                    onChange={handleChange}
                    style={{ width: "50%" }}
                    type="number"
                    maxLength={3}
                    regexType={regexTypes.number}
                    disabled={!data.boPeriod || hideButtons}
                  />

                  <span style={{ marginLeft: "10px" }}>
                    {data.boNotificationDate}
                  </span>
                </SC.Wrapper>
                <div style={{ marginTop: "2px" }}>
                  <CalendarDropdown
                    name="boNotificationCalenderType"
                    onChange={handleChange}
                    defaultValue={data?.boNotificationCalenderType}
                    disabledDropdown={hideButtons}
                  />
                </div>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>Coordinator</SC.Label>
              <SC.Children>
                <SC.Wrapper>
                  <TenantCoordinatorDropdown
                    name="tenantCoordinator"
                    onChange={handleChange}
                    defaultValue={data.tenantCoordinator || ""}
                    projectId={Projectdata?.id}
                    disabledDropdown={hideButtons}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>

            <SC.LabelContainer>
              <SC.Label>Activity Alarm</SC.Label>
              <SC.Children>
                <SC.Wrapper style={{ alignItems: "center", gap: "10px" }}>
                  <Checkbox
                    checked={data.activityAlarm === 1}
                    onChange={(e) =>
                      handleChange("activityAlarm", e.target.checked ? 1 : 0)
                    }
                    sx={{
                      "&.Mui-checked": {
                        color: theme.colors.themeColor,
                      },
                    }}
                    size="small"
                    disabled={hideButtons}
                  />
                  <span style={{ marginBottom: "2px" }}> Check interval</span>
                  <InputField
                    name="alarmInterval"
                    value={data.alarmInterval}
                    onChange={handleChange}
                    required
                    style={{ width: "20%" }}
                    type="number"
                    maxLength={2}
                    regexType={regexTypes.number}
                    disabled={hideButtons}
                  />
                  <WeekDaysDropdown
                    name="intervalCycle"
                    onChange={handleChange}
                    defaultValue={data.intervalCycle || ""}
                    disabledDropdown={hideButtons}
                  />
                </SC.Wrapper>
              </SC.Children>
            </SC.LabelContainer>
          </div>
        </SC.FormWrapper>

        <SC.ButtonContainer>
          {!isInfo && (
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
          )}
          {!hideButtons && (
            <Button
              caption={isEditing ? "Save" : "Add"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={hideButtons}
            />
          )}
        </SC.ButtonContainer>
      </SC.Form>
    </>
  );
}

export default GeneralInformationForm;
